import PersonalArea from './Area';
export default PersonalArea;